<template>
    <div class="content">
      <div>
        <transition name="fade" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </transition>
        <content-navigation></content-navigation>
        <i-a-m-pusher-handler v-if="iamNotificationsEnabled"></i-a-m-pusher-handler>
        <processing-modal></processing-modal>
      </div>
    </div>
</template>
<script>
import ContentNavigation from '@/components/Dashboard/Layout/ContentNavigation'
import { ENTRYPOINT } from '@/config/entrypoint'
import IAMPusherHandler from '@/components/Dashboard/Layout/IAMPusherHandler'
import ProcessingModal from '@/components/BaseComponents/processingModal'

export default {
  components: {
    ProcessingModal,
    IAMPusherHandler,
    ContentNavigation
  },
  computed: {
    iamNotificationsEnabled () {
      return ENTRYPOINT === 'https://iam.edusky.pl/core/public/index.php/api/'
    }
  }
}
</script>
<!--<script>-->
<!--(function (d, s, id) {-->
<!--  var js, fjs = d.getElementsByTagName(s)[0];-->
<!--  if (d.getElementById(id)) return;-->
<!--  js = d.createElement(s);-->
<!--  js.id = id;-->
<!--  js.src = 'https://chat.mysocialseller.com/res/js-chat/mss-webchat.min.js'-->
<!--  fjs.parentNode.insertBefore(js, fjs);-->
<!--}(document, 'script', 'mss-webchatjs'));-->
<!--MSSWEBCHAT = {-->
<!--  settings: {-->
<!--    color: '#2d9cdb',-->
<!--    server: 'https://chatbot.arcop.pl',-->
<!--    botId: 1251,-->
<!--    autoStart: 1,-->
<!--  }-->
<!--};-->
<!--MSSWEBCHAT.onChatbotStart = function () {-->
<!--};-->
<!--</script>-->
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>
